import { useLayoutEffect } from 'react';

import { initAiCio } from '../init';
import { conversationById, useConversationsStore } from '../store/conversations.store';

import { AiCioPanel } from './AiCioPanel';

export function hasAiCioConversation(id: string): boolean {
  return conversationById(useConversationsStore.getState().conversations, id) !== undefined;
}

export function useAiCioConversationExists(id: string | undefined): boolean {
  return useConversationsStore(
    (s) => id !== undefined && conversationById(s.conversations, id) !== undefined,
  );
}

export interface AiCioFileDockProps {
  conversationId: string;
  open: boolean;
}

export function AiCioFileDock({ conversationId, open }: AiCioFileDockProps) {
  const activeId = useConversationsStore((s) => s.activeId);

  useLayoutEffect(() => {
    initAiCio();
    const store = useConversationsStore.getState();
    if (hasAiCioConversation(conversationId) && store.activeId !== conversationId) {
      store.selectConversation(conversationId);
    }
  }, [conversationId]);

  if (activeId !== conversationId) return null;
  return <AiCioPanel docked={{ open }} />;
}
